module.exports = __webpack_public_path__ + "static/media/loading-spinner.2535ac46.gif";